export default __webpack_public_path__ + "static/media/icon-arrow-hint-orange.43acbed1.svg";